import { globalDevUtils } from './utils/globalDevUtils';
import { isDebugMode } from './utils/log-local';

export { PaymentElement } from './components/payment-element/PaymentElement';
export * from './@types';

if (isDebugMode()) {
  console.log('************************************************');
  console.log('   Payment SDK component loaded.');
  // eslint-disable-next-line
  console.log('   Build version:', (window as any)?.__PSDK_BUILD_VERSION__);
  // eslint-disable-next-line
  console.log('   Build date:', (window as any)?.__PSDK_BUILD_TIME__);

  // eslint-disable-next-line
  console.log('   Package location:', (window as any)?.__PSDK_PATH__);
  console.log('************************************************');

  console.log('Attached global dev utils to window.__dev__:', globalDevUtils);
}
